module.exports = __webpack_public_path__ + "static/media/empty-state-defects.787c5461.svg";